module.exports = "<h2>My Heroes</h2>\n\n<ul class=\"heroes\">\n    <li *ngFor=\"let hero of heroes\">\n      <a routerLink=\"/detail/{{hero.id}}\">\n        <span class=\"badge\">{{hero.id}}</span> {{hero.name}}\n      </a>\n    </li>\n  </ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/heroes/heroes.component.html
// module id = ./src/app/heroes/heroes.component.html
// module chunks = main